module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    staticStyle: {
      "padding-left": ".46rem"
    }
  }, [(!_vm.isChecked) ? _c('i', {
    staticClass: "iconfont icon-gengxin-xuankuang",
    on: {
      "click": function($event) {
        return _vm.chooseMember(_vm.item)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isChecked) ? _c('i', {
    staticClass: "iconfont icon-xuankuang",
    on: {
      "click": function($event) {
        return _vm.chooseMember(_vm.item)
      }
    }
  }) : _vm._e(), _vm._v("\n  " + _vm._s(_vm.item.userInfoName) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-135b4914"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox.vue
// module id = 217
// module chunks = 49